import { Controller } from '@hotwired/stimulus';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';

export default class extends Controller {
  static values = { token: String };
  static targets = ['input'];

  connect() {
    this.geocoder = new MapboxGeocoder({
      accessToken: this.tokenValue,
      types: 'address',
    });

    this.geocoder.addTo(this.element);
    this.geocoder.setInput(this.inputTarget.value);

    this.onResult = (event) => this._setInputValue(event);
    this.onClear = () => this._clearInputValue();
    this.geocoder.on('result', this.onResult);
    this.geocoder.on('clear', this.onClear);
  }

  _setInputValue(event) {
    this.inputTarget.value = event.result.place_name;
  }

  _clearInputValue() {
    this.inputTarget.value = '';
  }

  disconnect() {
    this.geocoder.off('result', this.onResult);
    this.geocoder.off('clear', this.onClear);
    this.geocoder.onRemove();
  }
}
